(function(){
  var FEED = "https://marvelous-emu-462.convex.site/reviews/feed";
  function esc(s){var d=document.createElement("div");d.textContent=s==null?"":String(s);return d.innerHTML;}
  function stars(n){n=Math.round(Number(n)||0);var o="";for(var i=0;i<5;i++){o+=i<n?"\u2605":"\u2606";}return o;}
  function photosHtml(r){
    var m=(r.media||r.photos||[]).filter(function(p){return p&&(p.url||p.mediaUrl);});
    if(!m.length) return "";
    var before=m.filter(function(p){return (p.stage||"")==="before";})[0];
    var after=m.filter(function(p){return (p.stage||"")==="after";})[0];
    if(before&&after){
      return '<div class="bpr-pair">'+
        '<figure><img class="bpr-photo" loading="lazy" alt="Before installation" src="'+esc(before.url||before.mediaUrl)+'"><figcaption>Before</figcaption></figure>'+
        '<figure><img class="bpr-photo" loading="lazy" alt="After installation" src="'+esc(after.url||after.mediaUrl)+'"><figcaption>After</figcaption></figure></div>';
    }
    var one=after||m[0];
    return '<img class="bpr-photo" loading="lazy" alt="Completed installation" src="'+esc(one.url||one.mediaUrl)+'">';
  }
  function card(r){
    var who=[r.customerName||r.name||"Verified customer", r.location||r.town||""].filter(Boolean).join(", ");
    return '<div class="bpr-card"><span class="bpr-stars">'+stars(r.rating)+'</span>'+
      photosHtml(r)+
      (r.comment?'<p>&ldquo;'+esc(r.comment)+'&rdquo;</p>':'')+
      '<div class="bpr-who"><span>'+esc(who)+'</span><span class="bpr-badge">&#9733; Verified customer</span></div></div>';
  }
  try{
    fetch(FEED,{mode:"cors"}).then(function(r){return r.ok?r.json():null;}).then(function(d){
      var list=(d&&(d.reviews||d.items))||[];
      list=list.filter(function(r){return r&&(r.comment||((r.media||r.photos||[]).length));}).slice(0,9);
      if(!list.length) return;
      document.getElementById("bpr-install-grid").innerHTML=list.map(card).join("");
      document.getElementById("bpr-installs").style.display="block";
    }).catch(function(){});
  }catch(e){}
})();
